var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChart',{attrs:{"id":_vm.chartID,"chart-options":_vm.mChartOptions,"chart-data":_vm.mChartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }